import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, ArrowCounterClockwise } from '@phosphor-icons/react';
import { Button } from '../Button';
import type { Intent } from './options';
interface SuccessCardProps {
  intent: Intent;
  selectionLabel: string;
  onReset: () => void;
}
export function SuccessCard({
  intent,
  selectionLabel,
  onReset
}: SuccessCardProps) {
  return <motion.div initial={{
    opacity: 0,
    scale: 0.97,
    y: 12
  }} animate={{
    opacity: 1,
    scale: 1,
    y: 0
  }} transition={{
    type: 'spring',
    stiffness: 420,
    damping: 32
  }} role="status" aria-live="polite" className="border-2 border-[hsl(var(--foreground))] bg-[hsl(var(--card))] p-8 text-center shadow-sm sm:p-10" data-id="element-106">
      <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-[hsl(var(--muted-foreground))]" data-id="element-107">
        Form CU-1040-R · Official Document
      </p>
      <div className="mx-auto mt-2 w-24 border-t-4 border-double border-[hsl(var(--foreground))]/70" data-id="element-108" />

      <h2 className="mt-6 font-serif text-2xl font-semibold tracking-tight text-[hsl(var(--foreground))]" data-id="element-109">
        Certificate of Receipt and Immediate Disposal
      </h2>
      <p className="mx-auto mt-3 max-w-md text-sm leading-relaxed text-[hsl(var(--muted-foreground))]" data-id="element-110">
        This certifies that your{' '}
        {intent === 'compliment' ? 'compliment' : 'complaint'} was received in
        full, reviewed by no one, and forwarded directly to disposal. No action
        will be taken. Thank you for your continued lack of input.
      </p>

      <motion.div initial={{
      opacity: 0,
      scale: 1.6,
      rotate: -14
    }} animate={{
      opacity: 1,
      scale: 1,
      rotate: -6
    }} transition={{
      type: 'spring',
      stiffness: 600,
      damping: 28,
      delay: 0.25
    }} className="mt-7" data-id="element-111">
        <span className="stamp" data-id="element-112">Received — Disregarded</span>
      </motion.div>

      <div className="mt-8 border border-[hsl(var(--border))] bg-[hsl(var(--muted))]/40 p-4 text-left" data-id="element-113">
        <dl className="space-y-2.5 text-sm" data-id="element-114">
          <div className="flex items-start justify-between gap-4" data-id="element-115">
            <dt className="font-mono text-xs uppercase tracking-wide text-[hsl(var(--muted-foreground))]" data-id="element-116">
              Primary Sentiment
            </dt>
            <dd className="text-right font-medium text-[hsl(var(--foreground))]" data-id="element-117">
              {selectionLabel}
            </dd>
          </div>
          <div className="flex items-start justify-between gap-4 border-t border-[hsl(var(--border))] pt-2.5" data-id="element-118">
            <dt className="font-mono text-xs uppercase tracking-wide text-[hsl(var(--muted-foreground))]" data-id="element-119">
              Data Collection
            </dt>
            <dd className="text-right font-medium text-[hsl(var(--foreground))]" data-id="element-120">
              All 35 data points have been received and shredded in the order
              they arrived.
            </dd>
          </div>
        </dl>
      </div>

      <div className="mx-auto mt-8 max-w-[14rem]" data-id="element-121">
        <div className="barcode" aria-hidden="true" data-id="element-122" />
        <p className="mt-1.5 font-mono text-[10px] tracking-[0.3em] text-[hsl(var(--muted-foreground))]" data-id="element-123">
          CU1040-00000-VOID
        </p>
      </div>

      <Button type="button" variant="outline" onClick={onReset} className="mt-6" data-id="element-124">
        <ArrowCounterClockwise size={16} className="mr-2" data-id="element-125" />
        Send another useless message
      </Button>
    </motion.div>;
}